<template>
  <div>
    <v-card flat>
      <v-card-text >
        <v-divider class="my-2"></v-divider>
        <filter-data
          with_client_portfolios
          with_text_search
          :with_client="false"
          :with_date_start="false"
          :with_date_end="false"
          @doneFilter="handleDoneFilter"
        />
        <v-data-table :search="tableSearch" :loading="loading.clients" :headers="headers" :items="clients">
          <template v-slot:item.attributes.original_limit="{item}">
            {{ Number(item.attributes.original_limit).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>
          <template v-slot:item.attributes.bonus="{item}">
            {{ Number(item.attributes.bonus).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>
          <template v-slot:item.attributes.limit="{item}">
            {{ Number(item.attributes.limit).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>
          <template v-slot:item.attributes.open_vrts_sum="{item}">
            {{ Number(item.attributes.open_vrts_sum).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Api from "@/api/index";

export default {
  name: "AvailableBonus",
  components: {
    FilterData: () => import("@/components/shared/FilterData.vue"),
  },
  data() {
    return {
      clients: [],
      local_filter: {},
      loading:{
        clients: false,
      },
      headers: [
        { text: 'Cliente', value: 'attributes.name' },
        { text: 'Limite Original', value: 'attributes.original_limit' },
        { text: 'Bônus Disponível', value: 'attributes.bonus' },
        { text: 'Crédito Disponível', value: 'attributes.limit' },
        { text: 'Faturas em aberto', value: 'attributes.open_vrts_sum' },
      ],
    };
  },
  computed:{
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
  },
  methods: {
    handleDoneFilter(filter){
      this.local_filter = { ...filter }
      this.getClients()
    },
    getData() {
      this.getClients()
    },
    getClients(){
      if(this.activeModalityId){
        this.clients = []
        this.loading.clients = true
        let params = {
          with_bonus: true,
          only_with_bonus: true,
          modality_id: this.activeModalityId,
          ...this.local_filter,
        }
        this.$emit("filters", params)
        Api.Client.index(params).then( res => res.data).then(res => {
          this.clients = [...res.data]
        }).finally(()=>{
          this.loading.clients = false
        })
      }
    },

  },
  mounted() {
    this.getData();
  },
  watch:{
    activeModalityId(){
      this.getData()
    },
  }
};
</script>